import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=d2a3a032&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=d2a3a032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a3a032",
  null
  
)

export default component.exports